import React, { useEffect, useState } from 'react'
import { Button, Skeleton } from 'antd'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { SVGIcon } from 'components'
import {
  getFundraiser,
  getSubscriberMarkupInfo,
  getSubscriberPaymentInformation,
} from 'store/fundraiserSlice/fundraiserActions'
import {
  fundraiserActions,
  useFundraiserSelector,
} from 'store/fundraiserSlice/fundraiserReducer'
import { BeforeJoinForm, FundraiserDetail } from './components'

const JoinFundraiser = () => {
  const [isJoined, setJoined] = useState(false)
  const { joinedFundraiserDetails } = useFundraiserSelector()
  const [fundraiser, setFundraiser] = useState()
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()
  const history = useHistory()
  const params = useParams()

  const getById = async () => {
    try {
      const detail = await getFundraiser(params?.id)
      setFundraiser(detail)
      setLoading(false)
    } catch (error) {
      console.log('error', error)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (params?.id) {
      getById()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id])

  useEffect(() => {
    if (fundraiser) {
      dispatch(getSubscriberPaymentInformation(fundraiser?.organizationId))
      dispatch(getSubscriberMarkupInfo(fundraiser?.organizationId))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fundraiser])

  const joinFundraiser = () => {
    setJoined(true)
    history.push(history.location.pathname)
  }

  useEffect(() => {
    const isDirect = new URLSearchParams(history.location.search).get('direct')
    if (isDirect) {
      joinFundraiser()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const moveNext = (values) => {
    dispatch(fundraiserActions.setJoinedFundraiserDetails(values))
    setJoined(true)
  }

  useEffect(() => {
    if (!joinedFundraiserDetails) {
      setJoined(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joinedFundraiserDetails])
  return (
    <Skeleton loading={loading} active paragraph={{ rows: 10 }}>
      {fundraiser ? (
        <>
          {!isJoined && !joinedFundraiserDetails ? (
            <BeforeJoinForm moveNext={moveNext} />
          ) : (
            <FundraiserDetail />
          )}
        </>
      ) : (
        <div className="ant-result ant-result-404">
          <SVGIcon />
          <div className="ant-result-title">An Error Occurred</div>
          <div className="ant-result-subtitle">
            Sorry, the could not get fundraiser details.
          </div>
          <div className="ant-result-extra">
            <Button
              onClick={() => window.location.reload(false)}
              type="primary"
              size="small"
            >
              Try Again
            </Button>
          </div>
        </div>
      )}
    </Skeleton>
  )
}

export { JoinFundraiser }
